type Stat = {
  description: string;
  stat?: string;
  href: string;
  target: string;
  starts?: string;
};

const STATS: Stat[] = [
  {
    description: 'College basketball',
    starts: '231-236-12',
    href: '/order',
    target: '_self',
  },
  {
    description: 'NFL sides & totals',
    stat: '54-32-3',
    // units: '+5.6',
    // percentage: '57.41',
    href: 'https://www.handicapper.net/nfl-picks-2023.php',
    target: '_blank',
  },
  {
    description: 'NFL props & futures',
    stat: '18-18',
    // units: '+3.4',
    // percentage: '66.67',
    href: 'https://www.handicapper.net/nfl-props-2023.php',
    target: '_blank',
  },
  {
    description: 'College football',
    stat: '77-53-3',
    // units: '+13.5',
    // percentage: '58.33',
    href: 'https://www.handicapper.net/college-football-picks-2023.php',
    target: '_blank',
  },
];

export default function Stats() {
  return (
    <div className="border-b border-zinc-600/50 bg-gradient-to-b from-zinc-950 via-transparent to-black">
      <div className="mx-auto w-full pt-8 sm:w-fit sm:py-8">
        <div className="mb-0 text-center text-base font-semibold text-emerald-500 sm:mb-8">
          Current service records
        </div>
        <dl className="mx-auto grid grid-cols-1 divide-y divide-zinc-600/80 px-4 text-white sm:grid-cols-2 sm:gap-8 sm:divide-x-0 sm:divide-y-0 sm:px-0 lg:flex lg:gap-0 lg:divide-x">
          {STATS.map(({ stat, description, starts, href, target }, index) => (
            <div key={index} className="w-full py-6 text-center sm:py-0 md:px-16 lg:w-fit xl:px-20">
              <a href={href} target={target} rel="noreferrer">
                <div className="space-y-2">
                  <dt className="text-sm font-semibold leading-5 text-zinc-400">{description}</dt>
                  <dd className="text-4xl font-semibold tracking-tight text-white hover:text-zinc-200">
                    {stat || starts}
                  </dd>
                </div>
              </a>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
}
